import { getHttpClient } from './httpClient';

export interface PlanTier {
  id: string;
  slug: string;
  name: string;
  price_monthly_cents: number;
  price_annual_cents: number;
  pricing_model: 'per_team' | 'flat';
  features: string[];
  is_public: boolean;
  is_active: boolean;
  included_seats_per_team: number;
}

export interface FeatureRegistry {
  modules: string[];
  subFeatures: Record<string, string[]>;
}

export async function getPlans(): Promise<PlanTier[]> {
  const { data } = await getHttpClient().get('/api/admin/plans');
  return data;
}

export async function getFeatureRegistry(): Promise<FeatureRegistry> {
  const { data } = await getHttpClient().get('/api/admin/features');
  return data;
}

export async function updatePlanFeatures(planId: string, features: string[]): Promise<PlanTier> {
  const { data } = await getHttpClient().put(`/api/admin/plans/${planId}/features`, { features });
  return data;
}
